
export const getDate = () => new Date();